module.exports = __webpack_public_path__ + "fonts/settle.svg";